/* eslint-disable react/jsx-props-no-spreading */
import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import ConfigPicker from '../../../../components/ConfigPicker/ConfigPicker';
import ConfigRow from '../../../../components/ConfigRow/ConfigRow';
import WebConfigContactBlock from '../../components/WebConfigContactBlock/WebConfigContactBlock';
import WebConfigMetaBlock from '../../components/WebConfigMetaBlock/WebConfigMetaBlock';
import configWebStore from '../../stores';
import { IConfigWeb, IConfigWebConfiguration } from '../../types';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import { localeStore } from 'src/mobx/localesStore';
import { LOCALES } from 'src/constants/main';
import './style.scss';

const WebConfigConfigurationTab: FC = observer((): JSX.Element => {
  const { changeConfigLanguagePicker, changeConfigAppLinks, changeConfigSocialLinks } = configWebStore;
  const { ios, android, oneLink } = configWebStore.configuration.appLinks;
  const { facebook, instagram, twitter, whatsApp, youtube, tiktok, snapchat } = configWebStore.configuration.socialLinks;

  const changeLanguagePicker = useCallback((value: string | number) => {
    changeConfigLanguagePicker(value as IConfigWeb['configuration']['defaultLanguage']);
  }, []);

  const changeAppLinks = (field: keyof IConfigWebConfiguration['appLinks']) => (value: string | undefined) => {
    changeConfigAppLinks({ [field]: value });
  };

  const changeSocialLinks = (field: keyof IConfigWebConfiguration['socialLinks']) => (value: string | undefined) => {
    changeConfigSocialLinks({ [field]: value });
  };

  const pickerOptions = useMemo((): IPickerOption[] => {
    return [
      { value: LOCALES.EN, label: localeStore.t('english') },
      { value: LOCALES.AR, label: localeStore.t('arabic') },
    ];
  }, []);

  const rowProps = { className: 'web-config-row', titleClassName: 'web-config-row__title', inputClassName: 'web-config-row__input' };

  return (
    <div className="d-flex flex-column mt-4">
      <ConfigPicker
        title="default_language"
        activeTab={configWebStore.configuration.defaultLanguage}
        options={pickerOptions}
        onChangeTab={changeLanguagePicker}
        className="web-config-picker"
        titleClassName="web-config-picker__title"
      />

      <WebConfigContactBlock />

      <WebConfigMetaBlock />

      <Text type={TEXT.SECTION_HEADER} text="applications_links" className="mt-6" />
      <div className="d-flex flex-column mt-4 gap-15">
        <ConfigRow title="IOS" value={ios} onChange={changeAppLinks('ios')} noTranslate {...rowProps} />
        <ConfigRow title="Android" value={android} onChange={changeAppLinks('android')} noTranslate {...rowProps} />
        <ConfigRow title="One Link " value={oneLink} onChange={changeAppLinks('oneLink')} noTranslate {...rowProps} />
      </div>

      <Text type={TEXT.SECTION_HEADER} text="social_links" className="mt-6" />
      <div className="d-flex flex-column mt-4 gap-15">
        <ConfigRow title="Facebook" value={facebook} onChange={changeSocialLinks('facebook')} noTranslate {...rowProps} />
        <ConfigRow title="Instagram" value={instagram} onChange={changeSocialLinks('instagram')} noTranslate {...rowProps} />
        <ConfigRow title="Twitter " value={twitter} onChange={changeSocialLinks('twitter')} noTranslate {...rowProps} />
        <ConfigRow title="WhatsApp" value={whatsApp} onChange={changeSocialLinks('whatsApp')} noTranslate {...rowProps} />
        <ConfigRow title="TikTok" value={tiktok} onChange={changeSocialLinks('tiktok')} noTranslate {...rowProps} />
        <ConfigRow title="YouTube" value={youtube} onChange={changeSocialLinks('youtube')} noTranslate {...rowProps} />
        <ConfigRow title="Snapchat" value={snapchat} onChange={changeSocialLinks('snapchat')} noTranslate {...rowProps} />
      </div>
    </div>
  );
});

export default WebConfigConfigurationTab;
